import { connect } from "react-redux";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { DialogConfirmation, } from "../generic/dialog-confirmation/DialogConfirmation";
import { actionModalClose, actionModalCloseAll } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionFacebookConnect } from "./actionFacebookConnect";
var mapState = function () { return ({
    messageLocaId: IdLoca.anotherSaveFound_confirmConnection_thisDeviceAccount,
    primaryBtnLocaId: IdLoca.confirm,
    titleLocaId: IdLoca.anotherSaveFound_confirmConnection_title,
}); };
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.FacebookConnectAnotherPlayerConnect)); },
    onConfirmation: function () {
        dispatch(actionFacebookConnect());
        dispatch(actionModalCloseAll());
    },
}); };
export var DialogFacebookAnotherPlayerConnect = connect(mapState, mapDispatch)(DialogConfirmation);



//////////////////
// WEBPACK FOOTER
// ./src/features/facebook/DialogFacebookAnotherPlayerConnect.tsx
// module id = 2824
// module chunks = 3